import type { SerializableNode } from '../types';
import type { TPostColumnElement } from './Columns.types';

function calculateAutoColumnWidth(columnsContent: SerializableNode[]) {
  // Find nested columns
  const nestedColumns = columnsContent.filter((child) => child.type === 'column') as TPostColumnElement[];

  // Determine the set widths of each column. Columns marked as "auto" will be 0
  const columnWidths = nestedColumns.map((column) => column?.attrs?.width);
  const sumOfWidths = ((columnWidths.filter(Boolean) as number[]) || []).reduce((pv, cv) => {
    return pv + cv;
  }, 0);
  const autoColumnsCount = columnWidths.filter((width) => !width).length;

  // Take the leftover amount of space we have and divide it between any auto width columns
  if (autoColumnsCount > 0) {
    return (100 - sumOfWidths) / autoColumnsCount;
  }
}

export { calculateAutoColumnWidth };
